import React from 'react'
import inputComponents from './inputs/inputComponents'
import tableComponents from './tableComponents/index'
import moment from 'moment';
import { checkTranslation, getObject, setObject, translate } from '../utils/useful'
import TLink from './TLink'
import Loader from 'react-loader-spinner'
import Month from './views/CalendarMonthlyView'
import TasksCalendar from '../windows/Desk/Eagleviews/tasksCalendar'

class SettingsViewer extends React.Component {
    constructor(props) {
        super(props)



        this.state = {
            errors: {},
            data: {},
            valid: {},
            dependencies: {},
            headers: [],
            // startDate: "",
            // dueDate: "",
            width: window.innerWidth,
            showCalendarPicker: false,
            // time: [

            //     { name: "{{lang}}Today", date: moment().format('ddd') },
            //     { name: "{{lang}}Later", date: moment().add(6, 'hours').format("h:mm") },
            //     { name: "{{lang}}Tomorrow", date: moment().add(1, 'days').format("ddd") },
            //     { name: "{{lang}}Next Week", date: moment().add(1, 'week').format("ddd") },
            //     { name: "{{lang}}Next Weekend", date: "sat" },
            //     { name: "{{lang}}2 Weeks", date: moment().add(2, 'weeks').format("MMM DD") },
            //     { name: "{{lang}}4 Weeks", date: moment().add(4, 'weeks').format("MMM DD") },
            //     { name: "{{lang}}8 Weeks", date: moment().add(8, 'weeks').format("MMM DD") },
            // ]
        }
    }
    componentDidMount() {
        // console.log(this.props.optionsList)
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {


        if ((JSON.stringify(this.props.initData) != JSON.stringify(prevProps.initData)) || (this.props.headers !== prevProps.headers)) {

            this.init()
        }
    }



    checkDependencies = () => {

        if (this.state.headers) {

            this.state.headers.forEach(header => {
                let hasDependency = (header.dependencies && header.dependencies.length > 0)
                if (hasDependency) {
                    let dependencies = this.state.dependencies
                    header.dependencies.forEach(dependency => {


                        let newDependency = JSON.parse(JSON.stringify(dependency))
                        newDependency.target = header.key

                        if (!dependencies[dependency.refKey]) {
                            dependencies[dependency.refKey] = []
                        }

                        dependencies[dependency.refKey].push(newDependency)
                        this.state.dependencies = dependencies

                    })
                }
            })

            if (this.state.data) {
                this.state.headers.forEach(prop => {
                    this.changeDependency(prop.key, this.state.data[prop.key], true)
                })
                this.changeDependency('*', null, true)

            }
        }
    }



    changeDependency(key, value, init) {
        let dependencies = this.state.dependencies
        // console.log("changeDependency")
        // console.log(dependencies)
        // console.log(key)
        if (dependencies[key]) {
            dependencies[key].forEach(dependency => {

                let conditions = dependency.conditions
                let variables = { data: this.state.data }
                // console.log(variables)
                let result = this.checkConditionGroup(conditions.root, variables)

                let headers = this.state.headers

                if (dependency.show != null) {
                    headers.forEach(header => {
                        if (dependency.targetKey == header.key) {
                            header.hideComponent = !result
                        }
                    });
                    this.setState({ headers })
                }

                if (dependency.changeValue != null) {
                    let data = this.state.data
                    data[dependency.targetKey] = data[dependency.refKey]
                    this.setState({ data })
                }


                if (dependency.changeHeader != null) {
                    headers.forEach(header => {
                        if (dependency.targetKey == header.key) {
                            // console.log(this.checkValueForVariables(dependency.changeHeader.value, variables))
                            // console.log(dependency.changeHeader.value)
                            // console.log(variables)
                            let newValue = this.checkValueForVariables(dependency.changeHeader.value, variables)
                            // console.log(newValue)
                            if (dependency.changeHeader?.converts) {
                                newValue = this.convertObject(newValue, dependency.changeHeader?.converts)
                            }
                            setObject(header, dependency.changeHeader.key, newValue)
                        }
                    })
                    this.setState({ headers })
                }



                if (dependency.init != null) {
                    if (this["component-" + dependency.targetKey] && this["component-" + dependency.targetKey].init) {
                        this["component-" + dependency.targetKey].init()
                    }
                }





            });

            this.setState({ dependencies })

        }
    }


    convertObject = (object, convert) => {
        let newObject

        if (Array.isArray(object)) {

            newObject = []
            object.forEach(oneInArray => {
                let tempNewObject = this.convertOneOfObject(oneInArray, convert)
                newObject.push(tempNewObject)
            });
        } else {
            newObject = this.convertOneOfObject(object, convert)
        }
        // console.log("return")
        return newObject

    }

    convertOneOfObject(object, convert) {
        let newObject = { ...object }
        convert.forEach(oneConvert => {
            newObject[oneConvert.targetKey] = newObject[oneConvert.valueKey]
        })

        // convert.forEach(oneConvert => {
        //     delete newObject[oneConvert.valueKey]
        // })


        return newObject
    }


    checkConditionGroup = (group, variables) => {
        let result = false
        if (group.action && group.action == 'and') {
            result = true
        }
        for (const [key, value] of Object.entries(group.conditions)) {
            if (this.checkOneCondition(value, variables) != result) {
                return !result
            }
        }

        return result
    }




    checkOneCondition = (condition, variables) => {
        let action = condition.action
        if (action) {
            return this.checkConditionGroup(condition, variables)
        } else {
            // source operator target
            let source = this.checkValueForVariables(condition.source.value, variables)
            let operator = condition.operator.value
            let target = this.checkValueForVariables(condition.target.value, variables)

            return this.checkOperator(source, operator, target)

        }
    }


    checkOperator(v1, operator, v2) {

        switch (operator) {
            case '==':
                return (v1 == v2)
            case '===':
                return (v1 === v2)
            case '!=':
                return (v1 != v2)
            case '!==':
                return (v1 !== v2)
            case '<':
                return (Number(v1) < Number(v2))
            case '<=':
                return (Number(v1) <= Number(v2))
            case '>':
                return (Number(v1) > Number(v2))
            case '>=':
                return (Number(v1) >= Number(v2))
            case '&&':
                return (v1 && v2)
            case '||':
                return (v1 || v2)
            default:
                return false
        }
    }


    checkValueForVariables = (value, variables) => {
        let newValue = value

        if (typeof newValue == "string") {
            newValue = value.split(' ')

            for (let i = 0; i < newValue.length; i++) {
                const element = newValue[i]
                if (element.startsWith('@')) {
                    // console.log(this.getValueOfVariable(element, variables))
                    newValue[i] = this.getValueOfVariable(element, variables)
                }
            }
            if (newValue.length > 1) {
                newValue = newValue.join(' ')
            } else {
                newValue = newValue[0]
            }
        }

        return newValue

    }

    getValueOfVariable(element, variables) {
        // console.log(element)
        let key = element.substring(1)
        key = key.split('.')
        let variableSource = key[0]
        key.splice(0, 1)
        key = key.join('.')

        return getObject(variables[variableSource], key)
    }



    // getForm = () => {
    //     // console.log(this.state.data)
    //     if (this.validator(this.state.headers, this.state.data).valid) {
    //         return this.state.data ? this.state.data : {}
    //     } else {
    //         return null
    //     }
    // }



    init = () => {
        // console.log(this.props.initData)
        if (this.props.headers) {
            let headers = JSON.parse(JSON.stringify(this.props.headers))
            this.setState({ headers }, () => {
                this.makeInitValue({ ...this.props.initData })

            })
        }
    }


    validator(headers, data) {
        let valid = true
        let errors = {}
        headers.forEach(header => {
            if (header.information?.required) {

                let value = getObject(data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput' || header.type == 'ImageProfileInput') {

                    if (!value || value === '') {
                        value = getObject(data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(data, header.key)
                    if (value == null || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'SubformInput') {
                    if (!value || value.length < 1) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    } else {
                        value.forEach(subValue => {
                            // header.information.headers.forEach(subHeader => {
                            // console.log(subHeader)
                            let validator = this.validator(header.information.headers, subValue)
                            if (!validator.valid) {
                                valid = false
                                // console.log(validator)
                                errors[header.key] = '{{lang}}errors.required-field'

                                // errors[header.key] = validator.errors
                            }
                            // });
                        });
                    }
                }
            }
        })
        // console.log(errors)
        this.setState({ errors })
        return { valid, errors }
    }




    makeInitValue(rawData) {
        // let newData = {}
        // this.setState({ data: newData, show: false }, () => {
        //     if (data) {
        //         for (const [key, value] of Object.entries(data)) {
        //             this.state.headers.forEach(header => {
        //                 if (header.key === key) {
        //                     newData[key] = value
        //                 }
        //             });
        //         }
        //     }

        let data = rawData
        if (data == null) {
            data = {}
        }

        this.state.headers.forEach(header => {
            if (data[header.key] == null && header.information?.default != null) {
                data[header.key] = header.information?.default
            }
        });


        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            this.checkDependencies()
            if (this.props.liveChange) {
                this.props.liveChange({ ...data }, true)
            }
        })
    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }

    changeFiles = (value, key, extra) => {
        let data = this.state.data ?? {}

        if (data['**files'] == null) {
            data['**files'] = {}
        }
        if (value) {
            value.formType = ''

            this.state.headers.forEach(header => {
                if (header.key == key) {
                    value.formType = header.type
                    // value.single = header.information?.single
                }
            });
        }

        data['**files'][key] = value
        // console.log(data)
        this.setState({ data })
    }

    changeValue = (key, value, extra) => {

        // console.log(key)
        // console.log(value)
        let data = { ...this.state.data }
        data = setObject(data, key, value, extra?.append)
        // console.log(data)
        this.setState({ data }, () => {
            this.changeDependency(key, value)
            if (this.props.liveChange) {
                this.props.liveChange(data, false, key, value, extra)
            }
        })
    }


    // setError = (key, value) => {
    //     let errors = this.state.errors
    //     errors[key] = value
    //     this.setState({ errors })

    // }

    // setValid = (key, value) => {
    //     let valid = this.state.valid
    //     valid[key] = value
    //     this.setState({ valid })
    // }


    setStatus = (type, key, value) => {
        let errors = this.state.errors
        let valid = this.state.valid


        delete errors[key]
        delete valid[key]

        if (type == 'error') {
            errors[key] = value
        }
        if (type == 'valid') {
            valid[key] = value
        }

        this.setState({ errors, valid })

    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        if (600 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }

    changeSection = (section) => {

        this.setState({ currentSection: section })
    }

    startEditting = (header, index) => {
        let headers = this.state.headers
        headers[index].isEditing = true
        this.setState({ showCalendarPicker: !this.state.showCalendarPicker })
    }

    cancelEditting = (header, index) => {
        let headers = this.state.headers
        headers[index].isEditing = false
        let oldData = getObject(this.props.initData, header.key)
        let data = this.state.data
        setObject(data, header.key, oldData)
        this.setState({ headers, data })
    }


    saveSetting = (header, index) => {
        let headers = this.state.headers
        let key = header.key

        let value = this.state.data[key]

        // if ((value == '' || value == null) && header.information.required) {

        //     return
        // }

        if (this.validator([header], this.state.data).valid) {
            headers[index].isLoading = true
            let files = null
            if (this.state.data['**files'] && this.state.data['**files'][key]) {
                files = this.state.data['**files'][key]
            }
            // console.log(files)

            this.props.saveSetting(key, value, files, (res, err) => {
                headers[index].isLoading = false


                if (res) {
                    headers[index].isEditing = false
                    this.setState({ headers })
                    // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })

                } else {
                    let oldData = getObject(this.props.initData, header.key)
                    let data = this.state.data
                    setObject(data, header.key, oldData)
                    this.setState({ headers, data })
                    // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.saveFailed', description: err?.message })
                }
            })

        } else {
            return
        }
    }

    render() {
        if (this.state.show && this.state.headers) {
            return (
                <section className={"w-100 form " + this.props.formClass} ref={(el) => this.form = el}>
                    <div className="w-100 m-0 flex-column d-flex">
                        {this.state.headers && this.state.headers.map((header, index) => {
                            let Component = inputComponents[header.type]
                            let ShowComponent = tableComponents[header.type]

                            let data = getObject(this.state.data, header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                            let files
                            if (this.state.data && this.state.data['**files']) {
                                files = getObject(this.state.data['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                            }

                            // console.log(header.key)
                            // console.log(data)
                            // console.log(header.information?.default)

                            if (data == null && header.information?.default != null) {
                                // console.log(header.information?.default)

                                data = header.information?.default
                            }

                            if (header.type == 'SectionIndicator') {
                                return (
                                    <div className="w-100 text-start w-100 px-2 " >

                                        <p style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '10px 8px' }} className={'w-100 text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTranslation(header.information?.label)}</p>
                                    </div>
                                )

                            } else if (header.type == 'SwitchInput') {
                                return (

                                    <div className="w-100  text-start form-row" style={{ minHeight: 40 }}>
                                        <div className={' flexc justify-content-end h-100 ' + (header.information.componentClass ?? '')} style={{ minHeight: 40 }}>
                                            <div className="p-0 w-100 flexcb h-100 cursor-pointer">
                                                <div className='col-6 text-start flexc'>
                                                    <label className={'form-label text-small mrd-1 mld-1 cursor-pointer  ' + (header.information?.required ? 'required' : '')}>{checkTranslation(header.information?.label)}</label>
                                                </div>
                                                <div className="col-6  d-flex flex-column" key={header.key} style={{ justifyContent: 'center', alignItems: 'flex-end', minHeight: 40 }}>
                                                    <div>
                                                        <Component changeValue={this.changeSection} data={this.state.currentSection} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else {


                                if (!header.hideComponent && (header.section == null || header.section == this.state.currentSection)) {

                                    return (
                                        <div key={header.key} className={"p-0 " + this.formColBuilder(header.col) + (index !== header.length - 1 ? ' ' : '')}>



                                            <div className="row m-0 form-row " style={{ borderBottom: (index != this.state.headers.length - 1) ? null : 'none' }}>
                                                <div className='flexc w-100'>
                                                    <div className=" text-start flexc flex-wrap mrd-2" style={{ flex: this.props.singleSide ? null : 1, }}>

                                                        <div style={{ minWidth: this.props.labelWidth ?? 150 }}>
                                                            <label className={'form-label text-small mrd-2  ' + (header.information?.required ? 'required' : '')}>{checkTranslation(header.information?.label)}</label>
                                                        </div>

                                                        {(!header.inPlaceEdit && !this.props.hideEditButton && (!header.isEditing && (data != null && data != ''))) && (
                                                            <button className='p-1 flexcc form-edit-button' onClick={() => this.startEditting(header, index)}>
                                                                {/* <div className='flexcc'>
                                                                        <img className='px-1 ' src={'/assets/icons/applets/general/edit.png'} height={12} style={{}} />
                                                                    </div> */}
                                                                <p className='text-smaller text-semibold' style={{ color: '#48A4DF', lineHeight: 0 }}>{translate("Edit")}</p>
                                                            </button>
                                                        )}


                                                        {(!this.props.singleSide && !header.isLoading && header.isEditing) && (
                                                            <div className='flexcc px-1' >
                                                                <button onClick={() => this.saveSetting(header, index)} className='flexc py-0 px-2 flex-1  mx-1 text-semibold  text-small' style={{ color: '#fff', background: 'linear-gradient(to right,#9564FE, #7064FE)', border: '1px solid transparent', borderRadius: 4 }} >
                                                                    <p className='text-small m-0 p-0'>{translate("Save")}</p>
                                                                </button>
                                                                <button onClick={() => this.cancelEditting(header, index)} className='flexc py-0 px-1 flex-1  text-semibold text-small' style={{ color: '#999', backgroundColor: '', border: '1px solid transperent', borderRadius: 4 }} >
                                                                    <p className='text-small m-0 p-0' >{translate("Discard")}</p>
                                                                </button>
                                                            </div>
                                                        )}

                                                        {(!this.props.singleSide && header.isLoading && header.isEditing) && (
                                                            <div className='flexc mx-2 h-100'>
                                                                <Loader
                                                                    type="ThreeDots"
                                                                    color="#39f"
                                                                    height="10"
                                                                    width="30"
                                                                />
                                                            </div>
                                                        )}

                                                    </div>



                                                    <div className="flex-1 d-flex  form-content-side" style={{ alignItems: this.props.singleSide ? '' : 'flex-end', minHeight: 38 }}>
                                                        <div className='w-100 '>
                                                            {!header.isEditing && ShowComponent && (
                                                                <div className={' flexc flex-1 ' + (this.props.singleSide ? "" : " justify-content-end ") + (header.information.componentClass ?? '')} style={{ minHeight: 38 }}>
                                                                    {(data != null && data != '') && (
                                                                        <div className='w-100 form-show-cell' onClick={() => { if (!header.inPlaceEdit) this.startEditting(header, index) }}>
                                                                            <ShowComponent ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} />
                                                                        </div>
                                                                    )}

                                                                    {!header.isEditing && (data == null || data == '') && (
                                                                        <button onClick={() => this.startEditting(header, index)} className='flexc  form-add-button' style={{}} >
                                                                            <p>{translate('Add')}</p>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {header.isEditing && Component && (
                                                                <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : 'default-input-view ')) + ' ' + ((this.state.valid[header.key] ? ' valid-input ' : ' ') + (this.state.errors[header.key] ? ' error-input ' : ' '))} >
                                                                    {/* {header.information?.icon && (
                                                                <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                                            )} */}

                                                                    <div className={'w-100 h-100' + (header.information.componentClass ?? '')}>
                                                                        <Component ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {(this.props.singleSide && header.isEditing) && (
                                                            <div className='flexcc'>

                                                                <div className='flexcc px-1' >
                                                                    <button onClick={() => { if (!header.isLoading) this.saveSetting(header, index) }} className='flexc py-0 px-2 flex-1  mx-1 text-semibold  text-small' style={{ color: '#fff', background: 'linear-gradient(to right,#9564FE, #7064FE)', border: '1px solid transparent', borderRadius: 4 }} >


                                                                        <p className='text-small m-0 p-0' style={{ opacity: header.isLoading ? 0 : 1 }}>{translate("Save")}</p>

                                                                        <div className='flexc mx-2 position-absolute' style={{ opacity: header.isLoading ? 1 : 0 }}>
                                                                            <Loader
                                                                                type="ThreeDots"
                                                                                color="#fff"
                                                                                height="10"
                                                                                width="20"
                                                                            />
                                                                        </div>
                                                                    </button>
                                                                    <button onClick={() => { if (!header.isLoading) this.cancelEditting(header, index) }} className='flexc py-0 px-1 flex-1  text-semibold text-small' style={{ color: '#999', backgroundColor: '', border: '1px solid transperent', borderRadius: 4 }} >
                                                                        <p className='text-small m-0 p-0' >{translate("Discard")}</p>
                                                                    </button>
                                                                </div>


                                                            </div>
                                                        )}

                                                        {/* {(this.props.singleSide && header.isLoading && header.isEditing) && (
                                                            <div className='flexc mx-2 '>
                                                                <Loader
                                                                    type="ThreeDots"
                                                                    color="#6473FE"
                                                                    height="10"
                                                                    width="30"
                                                                />
                                                            </div>
                                                        )} */}

                                                    </div>

                                                </div>
                                                {header.information?.hint && (
                                                    <div className="w-100 mt-1 pld-2 text-start">
                                                        <small style={{ color: '#9ab', fontSize: 12 }}>{checkTranslation(header.information?.hint)}</small>
                                                    </div>
                                                )}
                                                {this.props.errors && this.props.errors[header.key] && (
                                                    <div className="w-100 mt-1 mld-2 text-start">
                                                        <small style={{ color: '#ee5050' }}>{checkTranslation(this.props.errors[header.key])}</small>
                                                    </div>
                                                )}
                                                {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                                    <div className="w-100 mt-1 mld-2 text-start">
                                                        <small style={{ color: '#ee5050' }}>{checkTranslation(this.state.errors[header.key])}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            }
                        })}

                        {this.props.errors && (typeof this.props.errors == 'string') && (
                            <div className="w-100 text-start">
                                <small style={{ color: '#ee5050' }}>{checkTranslation(this.props.errors)}</small>
                            </div>
                        )}
                    </div>

                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default SettingsViewer;